import React, { useContext } from 'react';
import { useFetchContext } from './useFetchContext';

const url = 'https://ml.spidermo.net/index.json'
const dnnContext = React.createContext();
export const useDnnContextProvider = () => useFetchContext(dnnContext, url);
export const useDnnContext = () => useContext(dnnContext);
